import { Button, Grid2, Typography } from "@mui/material";

import { TContactContent } from "../../utils/contact";

type TContactProps = {
  content: TContactContent;
};
const Contact: React.FC<TContactProps> = ({ content }) => {
  return (
    <Grid2 id="Contact" container>
      <Grid2 offset={{ md: 4 }} size={{ sm: 12, md: 4 }}>
        <Typography variant="subtitle2">{content.subtitle}</Typography>

        <Typography
          variant="h2"
          sx={{
            mb: 5,
            mt: 2,
            color: "text.primary",
            fontWeight: 600,
            position: "relative",
            display: "inline-block",
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: "-4px",
              left: 0,
              width: "100%",
              height: "2px",
              background: "linear-gradient(to right, #2563eb, transparent)",
            },
          }}
        >
          {content.title}
        </Typography>
        <Typography pl={4} pr={4} variant="body1">
          {content.description}
        </Typography>
        <Button
          variant="contained"
          href={`mailto:duyguevrimodabass@gmail.com`}
          sx={{ marginTop: "20px", boxShadow: "none" }}
        >
          {content.button}
        </Button>
      </Grid2>
    </Grid2>
  );
};

export default Contact;
